export default `float i = 0.0f;
  float u = 0.0f;
  float S = 6.0f;
  p--;
  for ( int j = 0; j++ < 8; p = abs( ++p ) - 1.0f )
    p.z =- p.z,
    u = dot( p, p ) * 0.6f,
    S /= u + 0.001f, 
    p /= u + 0.001f;
  return ( length( p.xz ) + p.y ) / S;
}`